
import React from 'react';
import {
  StripeProvider,
  Elements
} from 'react-stripe-elements';
import { connect } from 'react-redux';

import OrganizationDonateComponent from '../../components/app/Organization/OrganizationDonate';

import * as actions from '../../actions/organization/organization-donate';

const OrganizationDonate = (props) => {
  return (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_TEST_KEYS}>
      <Elements>
        <OrganizationDonateComponent {...props} />
      </Elements>
    </StripeProvider>
  );
};

export default connect(({ organization, user }) => ({ organizationDonate: organization.organizationDonate, user }), actions)(OrganizationDonate);
